export default {
  title: 'Email Preferences',
  button_save: 'Save',
  alert: {
    updated_successfully: 'Email Preferences applied successfully',
  },
};
